




import Vue from 'vue'
import EditEvent from '@/components/EditEvent.vue';
export default Vue.extend({
    components:{
        EditEvent,
    }
})
